import { render, staticRenderFns } from "./CheckTB.vue?vue&type=template&id=b53d4ca8"
import script from "./CheckTB.vue?vue&type=script&lang=js"
export * from "./CheckTB.vue?vue&type=script&lang=js"
import style0 from "./CheckTB.vue?vue&type=style&index=0&id=b53d4ca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports